<template>
    <div class="m_container">
        <Header :title="tougaoInfo.title" />
        <section v-loading="loading" class="m_section">
            <LoadMore v-if="list.length > 0" :on-load-more="onLoadMore" :enable-load-more="enableLoadMore">
                <ul class="list">
                    <li v-for="(item, index) in list" :key="index" class="list_item" @click="toDetail(item)">
                        <p class="title">{{ item.title }}</p>
                        <p class="desc" v-html="item.content" />
                        <p class="creat_at">{{ item.created_at }}</p>
                        <p class="stauts_wrap">
                            <span class="actived">{{ item.is_read ? $t('Notification.read') : $t('Notification.unread') }}</span>
                            <i class="iconfont icon-you" />
                        </p>
                    </li>
                </ul>
            </LoadMore>
            <div v-else class="nodatawrap">
                <img src="../../assets/images/nodata.png" alt="" class="nodata">
                <p>{{ $t('Notification.nodata') }}</p>
            </div>
        </section>
        <TabBar :current-tab="currentTab" />
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import LoadMore from '@/components/loadMore'
import { getTid, setTid } from '@/utils/cookies'
import { mapGetters } from 'vuex'
import { noticeList } from '@/api/notice'

export default {
    name: 'Message',
    components: { Header, TabBar, LoadMore },
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            currentTab: 'message',
            enableLoadMore: true,
            list: [],
            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },
            loading: false
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo'])
    },

    created() {
        this.tid ? setTid(this.tid) : ''
        this.getList()
    },

    methods: {
        getList() {
            this.loading = true
            noticeList(this.listQuery).then(res => {
                if (res.code === 200) {
                    this.list = [...this.list, ...res.data.list]
                    this.total = res.data.total

                    if (this.list.length >= this.total) {
                        this.enableLoadMore = false
                    }
                    this.loading = false
                }
            }).catch(() => { this.loading = false })
        },

        onLoadMore(done) {
            setTimeout(() => {
                if (!this.enableLoadMore) {
                    return
                }
                this.listQuery.page += 1
                this.getList()
                done()
            }, 200)
        },

        toDetail(item) {
            this.$router.push({ path: '/messageDetail', query: { tid: this.tid, id: item.id } })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #FFFFFF;

  .m_section {
    flex:1;
    padding-bottom: 100px;

    .list{
      padding: 0 15px;

      .list_item{
        margin-top: 10px;
        padding: 15px 15px 14px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        text-align: left;
        font-family: PingFang SC;
        position: relative;

        .title{
          line-height: 19px;
          font-size:14px;
          font-weight: 600;
          color: #333333;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }

        .desc{
          line-height: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .creat_at{
          line-height: 24px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }

        .stauts_wrap{
          position: absolute;
          bottom: 13px;
          right: 15px;
          font-size: 12px;
          color: #999999;

          .actived{
            color:#C72B1E;
          }

          .icon-you{
            font-size: 8px;
            padding-left: 4px;
          }
        }

      }
    }
  }
}
.nodatawrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  font-size: 14px;
  color: #999;
  text-align: center;
  .nodata {
    width: 153px;
    height: 100px;
    margin: 0 auto;
    padding: 10px;
  }
  p {
    padding-bottom: 10px;
  }
}
</style>
